import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { /*faCertificate*/ faSchool } from '@fortawesome/free-solid-svg-icons';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Parcours</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Avril 2026 - Juilet 2026"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Développeur web (Stage)</h3>
            <h4 className="vertical-timeline-element-subtitle">BRGM, Clermont-Ferrand, France</h4>
            <p>
              Développement d'un middleware (ETL) pour la transformation de graphes de termes et bases de données SQL en graphes sémantiques en TypeDB<br></br>
              Apprentissage du TypeQL et developement en TypeScript.<br></br>
              Adaptation et implémentation d’algorithmes par des logiques de gestion de la donnée.<br></br>
            </p>
          </VerticalTimelineElement>
          
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Mars 2025 - Mai 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Développeur logiciel (Stage)</h3>
            <h4 className="vertical-timeline-element-subtitle">Neskar, Le Puy-en-Velay, France</h4>
            <p>
              Création d'un outil de control de projet pour un ERP de gestion d'entreprise <br></br>
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2023 - 2026"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faSchool} />}
          >
            <h3 className="vertical-timeline-element-title">BUT Informatique</h3>
            <h4 className="vertical-timeline-element-subtitle">Le Puy-en-Velay (43)</h4>
            <p>
              Développement logiciel (C++,C#,Python)<br></br>
              Développement web (HTML5/Js/CSS3, PHP)<br></br>
              Framework (Symfony, Qt)<br></br>
              Développement graphique (OpenGL,Unity, Unreal Engine)<br></br>
              Mobile (Android Studio)<br></br>
              Outils de développement (Visual Studio)<br></br>
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2020 - 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faSchool} />}
          >
            <h3 className="vertical-timeline-element-title">Lycée Notre Dame du Château</h3>
            <h4 className="vertical-timeline-element-subtitle">Monistrol-sur-Loire (43)</h4>
            <p>
              Baccalauréat général
            </p>
          </VerticalTimelineElement>

        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;